import axios from "axios";

class HttpRequest {
  static async get(url: string) {
    try {
      const res = await axios({
        method: "GET",
        url,
      });
      return res.data;
    } catch (err: any) {
      return err;
    }
  }

  static async post(url: string, data: any) {
    try {
      const res = await axios({
        method: "POST",
        url,
        data,
      });
      return res.data;
    } catch (err: any) {
      console.log(err);
      return err;
    }
  }
  static async update(url: string, data: any, token: string) {
    try {
      const res = await axios({
        method: "PATCH",
        url,
        headers: {
          authToken: `${token}`,
        },
        data,
      });

      return res.data;
    } catch (err: any) {
      return err;
    }
  }
}

export default HttpRequest;
